import { t } from "i18next";
import React, { useState } from "react";
import DubaiLinkSelect from "./DubaiLinkSelect";
import useFormStyles from "./KPIsForm/themes";

import useMeaQuery from "qpr-base/apihooks/useMeaQuery";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import AlertMessage from "qpr-base/ui/components/AlertMessage";
import Loader from "qpr-base/ui/components/Loader";

type Props = {
  setFieldValue: (fieldName: string, value: string) => void;
  setSymbols?: React.Dispatch<React.SetStateAction<string[]>>;
  themeOptions: any;
  priorityOptions: any;
  filterByTheme: any;
  selectedGE: any;
  disabled?: boolean;
};

const ElementLocationForm = (props: Props) => {
  const classes = useFormStyles();
  const ctx = useAppContext();
  const [changeMade, setChangeMade] = useState(false);

  const { data: topElementId, isLoading: topElementIdLoading } =
    useMeaQuery<any>(
      `[${ctx.fullModelId}].scorecard(criteria="symbol=\\"L0\\"").topelement`,
      "name"
    );

  const getElementId = (symbol: string, options: any): string => {
    const option: any = Object.keys(options)
      ?.filter((itm: any) => options[itm][0])
      .find((cur: any) => options[cur][0].symbol === symbol);
    return option ? options[option][0].id : "";
  };

  const handleFieldChange = async (symbol: string, field: string) => {
    if (!changeMade) {
      setChangeMade(true);
    }
    props.setFieldValue(field, symbol);

    const elementId = getElementId(
      symbol,
      field === "location.themesymbol"
        ? props.themeOptions
        : props.priorityOptions
    );
    props.setFieldValue("parentelementid", elementId);

    if (field === "location.themesymbol") {
      props.setFieldValue("location.prioritysymbol", "");
      props.filterByTheme({ symbol });
    }
  };

  const fields = [
    {
      name: "location.themesymbol",
      label: t("configtypes.Perspective"),
      type: "Perspective",
    },
    {
      name: "location.prioritysymbol",
      label: t("configtypes.Strategic Objective"),
      type: "Strategic Objective",
    },
  ];

  if (topElementIdLoading) return <Loader />;

  if (!topElementId) {
    return (
      <AlertMessage severity="info">{t("No data available")}</AlertMessage>
    );
  }

  return (
    <div className={classes.formWrapper}>
      <div className={classes.formColumn}>
        {fields.map((field, index) => (
          <DubaiLinkSelect
            handleFieldChange={handleFieldChange}
            index={index}
            label={field.label}
            elementType={field.type}
            name={field.name}
            topElementId={topElementId.data[0]?.id}
            {...props}
          />
        ))}
      </div>
    </div>
  );
};
export default ElementLocationForm;
